export enum CreditDecisionTypes {
	Approved = 'Approved',
	Investigation = 'Investigation',
	Rejected = 'Rejected',
	Invalid = 'Invalid',
	Error = 'Error',
}